import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-pencil",
  "use": "icon-s-pencil-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-pencil\"><path d=\"m16.997.56 4.414 4.414L4.393 22H0v-4.443zM13.985 6.4 2 18.385V20h1.556L15.57 7.985zm3.012-3.012L15.4 4.985l1.585 1.585 1.598-1.596z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol